// constants regardless of environment

export const APPNAME = 'websitegrader';

export const PRODUCTION = 'production';
export const STAGING = 'staging';
export const DEVELOPMENT = 'development';
export const UNKNOWN = 'unknown';

export const SENTRY_DSN = 'https://3d50aaf95e8f477ba3f151c303e46a91@sentry.io/1513690';
